import { LOADING_STATE } from "./store.constants";

export const isLoading = (status) => status === LOADING_STATE.LOADING;
export const isError = (status) => status === LOADING_STATE.ERROR;
export const isSuccess = (status) => status === LOADING_STATE.SUCCESS;
